"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mround_1 = require("./mround");
/**
 * obliczanie wartości procentowej
 * @param value wartość
 * @param totalValue wartośc odpowiadająca 100%
 */
function percent(value, totalValue) {
    if (totalValue === 0) {
        return 0;
    }
    else {
        var result = (value * 100) / totalValue;
        return result < 0 ? 0 : mround_1.default(result, 8);
    }
}
exports.default = percent;
//# sourceMappingURL=percent.js.map